<template>
<!--  <div v-show="visible">-->
  <div v-show="visible">
    <!-- popup -->
    <div id="popup_wrap" class="org_code_input">
      <div class="popup_title">
        <p>기관코드 입력</p>
        <button type="button" id="popup_close" class="btn_close" title="Close" @click="close">
          <div class="btn_close_box"><span></span><span></span></div>
        </button>
      </div><!-- //popup_title -->
      <div class="popup_content">
        <div class="box_area clfix">
          <div class="box_title_popup">기관코드<span class="required">*</span></div>
        </div>
        <select class="popup_select" v-model="companyCode">
          <option v-for="(opt,index) in sortedCompanyList" :key="index" :value="opt.value"
            :selected="index == 0? true:false">
            {{opt.text}}
          </option>
        </select>
      </div><!-- //popup_content -->
      <div class="popup_footer">
        <a class="btn_type1_big" @click="orgCodeUpdate">입력</a>
      </div><!-- //popup_footer -->
    </div>
    <div class="main_mask_wrap"></div>
    <!-- popup -->
    <Loading :visible="loading" type="fixed"/>
  </div>
</template>

<script>
import Loading from '@common/loading.vue';
import {createNamespacedHelpers} from 'vuex';
const Hub = createNamespacedHelpers('Hub');
const ProcessEditor = createNamespacedHelpers('ProcessEditor');

export default {
  components: {
    Loading,
  },
  data() {
    return {
      loading : null,
      visible : false,
      companyCode : "",
    }
  },
  computed : {
    ...Hub.mapGetters(
        [
            'getOrgCodeInputPopFlag'
      ]),
    sortedCompanyList() {
      const list = this.$store.getters["Hub/getOrgCodeArray"] || [];
      const sorted = [...list].sort((a, b) => a.text.localeCompare(b.text, "ko"));
      sorted.unshift({ value: "", text: "선택해주세요" });
      return sorted;
    },
  } ,
  watch: {
    getOrgCodeInputPopFlag: {
      deep : true,
      async handler (value) {
        if(value && this.user){
          this.show();
          await window.alert("기관코드 입력이 필요합니다.");
        }else{
          this.visible = false;
        }
      }
    },
  },
  async mounted() {
  },
  methods: {
    ...Hub.mapMutations(
        ['setOrgCodeInputPopFlag']
    ),
    async orgCodeUpdate() {
      if (this.companyCode == null || this.companyCode == '') {
        alert("기관고유코드를 선택해주세요.");
        return;
      }
      try {
        const response = await this.$wApi.user.updateCompanyCode({
          companyCode: this.companyCode,
        });
        if (!response.error) {
          alert("입력되었습니다.")
          this.close()
        } else {
          alert("에러! 관리자에게 문의해주세요.");
        }
      } catch (e) {
        console.log(e);
        alert("에러! 관리자에게 문의해주세요.");
      }

    },
    show() {
      this.visible = true;
    },
    close() {
      this.setOrgCodeInputPopFlag(false);
    },
  }
}
</script>

<style lang="scss">
@import "@/style/new/css/cyl.common.css";

@media screen and (max-width: 950px) {
  .org_code_input {width:95%; height: 95%}
}
/* layer popup */
#popup_wrap  {display:block;  position:fixed;width:600px;height:300px;left:50%;top:50%;transform:translate(-50%,-50%); background:#fff;z-index:10001;border-radius:6px;}
.main_mask_wrap  {display:block;  width:100%;height:100%;position:fixed;filter:alpha(opacity=50);opacity:0.5;background-color:#000;top:0;left:0;z-index:900;}

.popup_title {position:relative;width:100%;height:60px;line-height:60px;background:#f6f7fb;color:#111;padding:0 15px;border-radius:7px 7px 0 0;}
.popup_title > p {font-family: 'Noto Sans KR Bold';font-weight:bold;color:#111;font-size:19px;}
.popup_content {position:absolute;top:60px;bottom:60px;left:0;right:0;padding:20px 15px;overflow-y:auto;}
.popup_footer {display:flex;flex-wrap:wrap;align-items:center;justify-content:flex-end;text-align:right;  position:absolute;bottom:0;width:100%;height:60px; padding:0 15px;background:#efefef;border-radius:0 0 7px 7px;}
.btn_close {position:absolute;width:30px;height:30px;top:17px;right:15px;cursor:pointer;}
.btn_close_box {margin:0;display:inline-block;position:relative;width:19px;height:19px;}
.btn_close_box span {display:inline-block; position:absolute;left:0;width:100%;height:2px;background-color:#111;border-radius:0px;}
.btn_close_box span:nth-of-type(1) {transform: translateY(6px) rotate(-45deg);}
.btn_close_box span:nth-of-type(2) {transform: translateY(6px) rotate(45deg);}

.box_title_popup {margin-bottom:10px;font-family: 'Noto Sans KR Medium';font-weight:bold;color:#111;font-size:16px;}
.popup_select {width:100%;height:50px;}
.popup_input {width:100%;height:50px;}
/* layer popup */
</style>